<template>
	<div v-if="isVisible" class="popup-container">
		<div class="card white popup">
			<h2>{{ title }}</h2>
			<div v-if="hasOptions" class="form-control">
				<label for="type">Sélectionner un type*</label>
				<select name="type" id="type" v-model="selectedType">
					<optgroup v-for="(categoryTypes, categoryName) in filteredGroupedTypes" :label="categoryName"
						:key="categoryName">
						<option v-for="type1 in categoryTypes" :key="type1.ID" :value="type1.name">{{ type1.name }}
						</option>
					</optgroup>
					<option value="autre">Autre</option>
				</select>
			</div>
			<div v-else class="form-control">
				<label for="customType">Entrez un nom</label>
				<input type="text" id="customType" v-model="customType" placeholder="Entrez un nom" v-alpha-numeric />
			</div>
			<div v-if="hasOptions && isCustomTypeSelected" class="form-control">
				<label for="customType">Entrez un nom</label>
				<input type="text" id="customType" v-model="customType" placeholder="Entrez un nom" v-alpha-numeric />
			</div>
			<div v-if="!isFileSelected" style="display: none">
				<input type="file" id="fileInput" ref="fileInput" @change="handleFileChange" />
			</div>
			<div v-if="selectedFile" class="file-entry">
				<i class="bi bi-file-earmark-pdf-fill"></i>
				<p class="file-name" @click="openPreview">{{ selectedFile.name }}</p>
				<p class="file-action u" @click="openPreview">Voir</p>
				<p>|</p>
				<p class="file-action u" @click="deleteFile">Supprimer</p>
			</div>
			<p v-if="errorMessage">{{ errorMessage }}</p>
			<div class="popup-actions">
				<button v-if="!isFileSelected" class="button fill orange"
					@click="simulateFileInputClick($event)">Ajouter un fichier</button>
				<button v-else class="button fill orange" @click="confirmAction" :disabled="isUploading">
					{{ confirmButtonText }}
				</button>
				<button class="button outline orange" @click="cancelAction" :disabled="isUploading">
					{{ cancelButtonText }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isVisible: Boolean,
		title: String,
		groupedTypes: Object,
		categorieID: {},
		propID: {},
		confirmButtonText: {
			type: String,
			default: "Confirmer",
		},
		cancelButtonText: {
			type: String,
			default: "Annuler",
		},
	},
	data() {
		return {
			selectedType: null,
			customType: "",
			selectedFile: null,
			errorMessage: "",
			isUploading: false,
		};
	},
	computed: {
		filteredGroupedTypes() {
			const filteredCategories = {};
			for (const [categoryName, types] of Object.entries(this.groupedTypes)) {
				const filteredTypes = types.filter((type) => type.categorieID === this.categorieID);
				if (filteredTypes.length > 0) {
					filteredCategories[categoryName] = filteredTypes;
				}
			}
			return filteredCategories;
		},
		hasOptions() {
			return Object.keys(this.filteredGroupedTypes).length > 0;
		},
		isCustomTypeSelected() {
			return this.selectedType === "autre";
		},
		isFileSelected() {
			return !!this.selectedFile;
		},
	},
	methods: {
		simulateFileInputClick(event) {
			event.preventDefault();
			event.stopPropagation();
			this.$refs.fileInput.click();
		},
		handleFileChange(event) {
			const selectedFileType = event.target.files[0].type;
			if (selectedFileType === "image/jpeg" || selectedFileType === "image/png" || selectedFileType === "application/pdf") {
				this.selectedFile = event.target.files[0];
			} else {
				this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
				event.target.value = null;
			}
		},
		async confirmAction() {
			if ((this.selectedType === "autre" && !this.customType) || (this.selectedType === null && !this.customType)) return this.errorMessage = "Aucun type sélectionné.";

			let typeToSend = this.selectedType;
			if (this.selectedType === "autre" || !this.selectedType) typeToSend = this.customType;

			try {
				this.isUploading = true;
				this.errorMessage = "";

				const formData = new FormData();
				formData.append("file", this.selectedFile);
				formData.append("propID", this.propID);
				formData.append("type", typeToSend);
				formData.append("categorie", this.categorieID);

				const response = await fetch(process.env.VUE_APP_API_URL + "fichiers/add", { method: "POST", credentials: "include", body: formData, });

				if (!response.ok) return this.errorMessage = "Une erreur est survenue lors de l'envoi.";
				this.$emit("confirm");
				this.resetForm();
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
				this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
			} finally {
				this.isUploading = false;
			}
		},
		resetForm() {
			this.selectedType = null;
			this.customType = "";
			this.selectedFile = null;
			this.errorMessage = "";
			this.isUploading = false;
		},
		cancelAction() {
			this.resetForm();
			this.$emit("cancel1");
		},
		openPreview() {
			if (!this.selectedFile) return;
			if (this.selectedFile.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const image = new Image();
					image.src = e.target.result;
					const previewWindow = window.open("", "_blank");
					previewWindow.document.write(image.outerHTML);
				};
				reader.readAsDataURL(this.selectedFile);
			} else if (this.selectedFile.type === "application/pdf") {
				const pdfUrl = URL.createObjectURL(this.selectedFile);
				const previewWindow = window.open(pdfUrl, "_blank");
				previewWindow.document.title = this.selectedFile.name;
			} else {
				this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
			}
		},
		deleteFile() {
			this.selectedFile = null;
		},
	},
};
</script>
